export const boldText = () => ({ amountText: { fontWeight: 700 } });
export const smallText = () => ({ amountText: { fontSize: 14, marginTop: '5px' } });
export const operationText = () => ({ item: { width: 110 } });
export const normalCell = () => ({});
export const smallCell = () => ({});
export const normalText = () => ({ amountText: { fontWeight: 'normal' } });
export const alignRight = () => ({ item: { textAlign: 'right' } });
export const paymentText = () => ({ item: { width: 140 } });
